import type { PlainDate } from "@sa-nu/shared-utils/date";

import { getDefaultReservationLeadMonths } from "../../../../constants";

import { getSameDayMinNight } from "./reservation-cutoff";

/**
 * 検索カレンダーの描画範囲。クエリの取得範囲と DatePicker の描画範囲の両方がこの関数を
 * 呼ぶことで、範囲のズレを防ぐ。
 */
export function getSearchCalendarRenderRange(today: PlainDate): {
  minDate: PlainDate;
  maxDate: PlainDate;
  renderMaxDate: PlainDate;
} {
  // 当日15時以降は当日を pre-fill できないよう、レガシー ticket-reservation-form と
  // 同じカットオフを下限にする
  const minDate = getSameDayMinNight();
  // 暫定の上限。本来は StayTicketUnit の stayEndNight で縛りたいが、予約カレンダー側が
  // サーバスコープ済みの availability で再クランプするため実害はなく、チケット期間の props
  // 配線は今後の改善に委ねる。それまでは今の予約リード月数 (getDefaultReservationLeadMonths)
  // で代用する。BE の DEFAULT_RESERVATION_LEAD_MONTHS とは値がハードコードで分離しているので、
  // 二重管理を避けるため getDefaultReservationLeadMonths 側を単一の参照元にする。
  const maxDate = today.add({ months: getDefaultReservationLeadMonths(today) });
  // 描画上限。最終泊が土曜だと CO 日(翌週日曜)が別週になり描画されないため、常に CO 日の週まで
  // 描画して CO セルを見せる。チェックイン選択前は selectableMaxDate=maxDate により薄グレー・選択不可。
  const renderMaxDate = maxDate.add({ days: 1 });

  return { minDate, maxDate, renderMaxDate };
}
